import store from '@/store'
import router from '@/router'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'

const config = {
  apiKey: 'AIzaSyDT0oF_IRFaOZGrwhcp7OqNRNkf7EpOAV4',
  authDomain: 'niloapp.firebaseapp.com',
  databaseURL: 'https://niloapp.firebaseio.com',
  projectId: 'niloapp',
  storageBucket: 'niloapp.appspot.com',
  messagingSenderId: '51272318906',
  appId: '1:51272318906:web:26c9a06cffeb01efa62783',
  measurementId: 'G-NVF9GFDZ03',
}

export default {
  install: (Vue, options) => {
    const firebaseApp = firebase.initializeApp(config)
    const auth = firebaseApp.auth()
    Vue.prototype.$auth = {
      login: async (username, pass) => {
        return auth.signInWithEmailAndPassword(username, pass)
      },
      logout: async () => {
        router.push('/user/login')
        await auth.signOut()
      },
    }
    auth.onAuthStateChanged(user => {
      store.commit('UPDATE_USER', { user })
    })
  },
}
